import React from 'react'
import COLOR from '../../global/Color'
import SIZE from '../../global/Size'

import HeaderContainer from '../../components/header/HeaderContainer'
import HeaderTitle from '../../components/header/HeaderTitle'
import HeaderContent from '../../components/header/HeaderContent'
import HeaderContentSmall from '../../components/header/HeaderContentSmall'
import DivideLine from '../../components/inner/venderProduct/DivideLine'
import LastHeaderContentSmall from '../../components/header/LastHeaderContentSmall'
import CenterAlignedContainer from '../../components/inner/venderProduct/CenterAlignedContainer'
import HorizontalMediaCard from '../../components/inner/venderProduct/HorizontalMediaCard'
import OmmnivisionTable from '../../components/inner/venderProduct/OmmnivisionTable'
import { useLanguage } from '../../context/LanguageContext';
import { siteCopy } from '../../i18n/landingCopy';

import mobileDevice01 from '../../assets/vendorProduct/mobiledevice01.png';
import mobileDevice02 from '../../assets/vendorProduct/mobiledevice02.png';
import automotiveImage01 from '../../assets/vendorProduct/automotiveImage01.png';
import automotiveImage02 from '../../assets/vendorProduct/automotiveImage02.png';
import surveillance01 from '../../assets/vendorProduct/surveillance01.png';
import surveillance02 from '../../assets/vendorProduct/surveillance02.png';

const Omnivision = () => {
  const { language } = useLanguage();
  const copy = siteCopy[language]?.pages?.vendor?.omnivision || siteCopy.en.pages.vendor.omnivision;

  const renderLines = (lines = []) =>
    lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < lines.length - 1 && <br />}
      </React.Fragment>
    ));

  const [mobileSection, automotiveSection, surveillanceSection] = copy.sections || [];

  return (
    <>
      <HeaderContainer>
        <HeaderTitle>{copy.title}</HeaderTitle>
        <HeaderContent>
        <span style={{color: COLOR.MAGORELLEBLUE, fontWeight: 700}}>{copy.title}
        <span style={{color: COLOR.BLACK, fontWeight: 300, display: 'inline-block'}}>
        </span>
        </span>(
          <a style={{textDecoration: 'underline', color: COLOR.BLACK}} href={copy.website} target='_blank'>
            {copy.website}
          </a>
        )
        {renderLines(copy.headerIntro)}
        </HeaderContent>

        <HeaderContentSmall>{renderLines(copy.bodyParagraphs.slice(0, 1))}</HeaderContentSmall>
        <HeaderContentSmall>{renderLines(copy.bodyParagraphs.slice(1, 2))}</HeaderContentSmall>
        <LastHeaderContentSmall>{renderLines(copy.bodyParagraphs.slice(2))}</LastHeaderContentSmall>

      </HeaderContainer>

      <DivideLine />

      <CenterAlignedContainer>
        <span style={{fontWeight: 600, color: COLOR.MAGORELLEBLUE, fontSize: SIZE.X1LARGE, paddingBottom: 25, textAlign: 'center' }}>{mobileSection?.title || 'Mobile Device'}</span>
        <span style={{textAlign: 'center', lineHeight: 1.5, fontSize: SIZE.MEDIUM2, paddingBottom: 50, paddingLeft: 50, paddingRight: 50}}>
          {mobileSection ? renderLines([mobileSection.subtitle]) : ''}
        </span>

        <HorizontalMediaCard 
          imageSrc1={mobileDevice01}
          title1={mobileSection?.cards[0]?.title}
          content1={mobileSection ? renderLines(mobileSection.cards[0]?.content || []) : null}
          imageSrc2={mobileDevice02}
          title2={mobileSection?.cards[1]?.title}
          content2={mobileSection ? renderLines(mobileSection.cards[1]?.content || []) : null}
        />

      </CenterAlignedContainer>

      <DivideLine />

      <CenterAlignedContainer>
        <span style={{fontWeight: 600, color: COLOR.MAGORELLEBLUE, fontSize: SIZE.X1LARGE, paddingBottom: 25, textAlign: 'center' }}>{automotiveSection?.title || 'Automotive Imaging'}</span>
        <span style={{textAlign: 'center', lineHeight: 1.5, fontSize: SIZE.MEDIUM2, paddingBottom: 50, paddingLeft: 50, paddingRight: 50}}>
          {automotiveSection ? renderLines([automotiveSection.subtitle]) : ''}
        </span>

        <HorizontalMediaCard 
          imageSrc1={automotiveImage01}
          title1={automotiveSection?.cards[0]?.title}
          content1={automotiveSection ? renderLines(automotiveSection.cards[0]?.content || []) : null}
          imageSrc2={automotiveImage02}
          title2={automotiveSection?.cards[1]?.title}
          content2={automotiveSection ? renderLines(automotiveSection.cards[1]?.content || []) : null}
        />
      </CenterAlignedContainer>

      <DivideLine />

      <CenterAlignedContainer>
        <span style={{fontWeight: 600, color: COLOR.MAGORELLEBLUE, fontSize: SIZE.X1LARGE, paddingBottom: 25, textAlign: 'center' }}>
        {surveillanceSection?.title || 'Surveillance'}
        </span>
        <span style={{textAlign: 'center', lineHeight: 1.5, fontSize: SIZE.MEDIUM2, paddingBottom: 50, paddingLeft: 50, paddingRight: 50}}>
          {surveillanceSection ? renderLines([surveillanceSection.subtitle]) : ''}
        </span>

        <HorizontalMediaCard 
          imageSrc1={surveillance01}
          title1={surveillanceSection?.cards[0]?.title}
          content1={surveillanceSection ? renderLines(surveillanceSection.cards[0]?.content || []) : null}
          imageSrc2={surveillance02}
          title2={surveillanceSection?.cards[1]?.title}
          content2={surveillanceSection ? renderLines(surveillanceSection.cards[1]?.content || []) : null}
        />
      <OmmnivisionTable headers={copy.tableHeaders} />
      <div style={{height: '5vh'}} />

      </CenterAlignedContainer>
    </>
  )
}

export default Omnivision
